module.exports = __webpack_public_path__ + "img/mobilkarta_popup.0defc2b1.svg";